import dayjs from "dayjs";
import React from "react";
import { useParams } from "react-router-dom";
import Link from "antd/es/typography/Link";
const capitalizeFirstLetter = (label) => label.charAt(0).toUpperCase() + label.slice(1);

export const CustomTable = ({ title, data, columns, dataLabel, Id, button = true, dateFieldsMap }) => {
  const { Empid } = useParams();
  return (
    <div>
      <div className="card profile-box flex-fill">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="card-title">{title}</h3>
            {Empid && button ? (
              <Link to="#" className="edit-icon" data-bs-toggle="modal" data-bs-target={`#${Id}`}>
                <i className="fa fa-pencil" />
              </Link>
            ) : null}
          </div>
          <div className="table-responsive">
            <table className="table table-nowrap text-center">
              <thead>
                <tr>
                  {columns?.map((col, index) => (
                    <th key={index}>{capitalizeFirstLetter(col)}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data?.length > 0 ? (
                  data?.map((item, index) => (
                    <tr key={index}>
                      {dataLabel.map((label, colIndex) => (
                        <td key={colIndex}>
                          {Array.isArray(item[label]) && item[label].length > 0 ? (
                            <>
                              {item[label][0]}
                              {item[label].length > 1 && " ..."}
                            </>
                          ) : dateFieldsMap?.[label] && item[label] ? (
                            dayjs(item[label]).format("DD/MM/YYYY")
                          ) : typeof item[label] === "boolean" ? (
                            item[label].toString()
                          ) : (
                            item[label]
                              ? item[label]
                              : label === 'to'
                                ? 'currently pursuing'
                                : 'null'
                          )}
                        </td>

                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={columns.length}>No data found</td>
                  </tr>
                )}
              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomTable;